import React from 'react'
import * as Columns from 'support/columns'
import ForEachWeekday from 'support/helpers/ForEachWeekday'
import EditInventoryNormQuantity from 'support/displays/inventory/EditInventoryNormQuantity'
import { useValue } from '@morningtrain/react-resources'
import { useEnvValue } from '@morningtrain/react-helpers'
import get from 'lodash/get'
import { toJS } from 'mobx'
import WhenOnScreen from 'support/conditionals/WhenOnScreen'

export default function NormItemCategoryWeekdayColumns () {
  const inventoryItemId = useValue('id')
  let normsByWeekday = useValue('norms_by_weekday')

  const [activeIndex] = useEnvValue('globals.inventory.norms.active_index', 100)

  normsByWeekday = toJS(normsByWeekday)

  return (
    <ForEachWeekday>
      {weekday => {
        const normForWeekday = get(normsByWeekday, weekday.index, {})

        return (
          <Columns.Column label={weekday.name} alignment='center'>
            <WhenOnScreen>
              <EditInventoryNormQuantity
                weekdayIndex={weekday.index}
                inventoryItemId={inventoryItemId}
                normAtDefault={normForWeekday.norm_at_default || 0}
                defaultNormOffset={parseFloat(normForWeekday.norm_offset) || 0}
                activeIndex={activeIndex}
              />
            </WhenOnScreen>
          </Columns.Column>
        )
      }}
    </ForEachWeekday>
  )
}
